module.exports = __webpack_public_path__ + "img/app-store.8652a7ed.png";